import { cols } from "@/config/system";
import { getStoreMapWithDicKey, mapValueFormat, momentFormat } from "@/utils/formatter";

export const tableColumn = [
  {
    type: "selection",
    width: cols.selection,
  },
  {
    label: "员工姓名",
    prop: "staffName",
    width: cols.auto
  },
  {
    label: "手机号",
    prop: "staffPhone",
    width: cols.auto
  },
  {
    label: "关联的电子面单账号",
    prop: "partnerList",
    showOverFlowTooltip: false,
    minWidth: cols.op4
  },
  {
    label: "账号状态",
    prop: "isEnabled",
    width: cols.auto,
    formatter: (row: any, column: any, cellValue: string) =>
      mapValueFormat(cellValue, getStoreMapWithDicKey('merchant_user_data_status')),
  },
  {
    label: "用户角色",
    prop: "roleType",
    width: cols.auto
  },
  {
    label: "注册日期",
    prop: "registrationData",
    width: cols.auto,
    formatter: (row: any, column: any, cellValue: string) =>
    momentFormat(cellValue, "YYYY-MM-DD HH:mm:ss")
  }, 
  {
    label: "操作",
    prop: "actions",
    width: cols.op3,
    slotName: 'actions'
  },
];
